module.exports = __webpack_public_path__ + "img/company-icon.09707528.svg";